<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="p-6">
        <vs-row>
          <vs-col class="mb-3" vs-w="12">
              <ValidationProvider name="locationCode" rules="numeric" v-slot="{ errors }">
              <validated-input
              :label="$t('GradeControl.Location.Code')"
              v-model="locationCode"
              ></validated-input>
              <validation-message
              >{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col class="mb-3" vs-w="12">
            <form-label>{{$t('GradeControl.Location.Type')}}</form-label>
            <ValidationProvider name="locationType" rules="numeric" v-slot="{ errors }">
              <v-select
              label="name"
              :options="locationTypes"
              :reduce="type => type.id"
              v-model="locationType"
              class="w-full"
              name="locationType"
              />
              <validation-message
              >{{ errors[0] }}</validation-message>
          </ValidationProvider>
          </vs-col>
        </vs-row>
      </div>
        <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="handleSubmit(submitData)" :disabled="!isFormValid">Submit</vs-button>
        <vs-button type="border" color="danger" @click="cancel">Cancel</vs-button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import {
  FormLabel,
  ValidatedInput,
  ValidationMessage
} from "./../../../../shared/components";
import LocationTypeEnum from "../../LocationTypeEnum.js";

export default {
  props: {
    projectId: {
      type: Number,
      required: true
    }
  },
  components: {
    vSelect,
    ValidatedInput,
    ValidationMessage,
    FormLabel
  },
  data() {
    return {
      locationProjectId: 0,
      locationId: 0,
      locationCode: "",
      locationType: LocationTypeEnum.Production,
      locationTypes: LocationTypeEnum.definition
    };
  },
  computed: {
    isFormValid() {
      return true;
      //return !this.errors.any();
    }
  },
  methods: {
    initValues() {
      this.locationCode = "";
      this.locationId = 0;
      this.locationType =  LocationTypeEnum.Production
    },
    cancel() {
      this.$emit("onCancel");
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            locationId: this.locationId,
            code: this.locationCode,
            type: this.locationType,
            projectId: this.projectId,
            cappings: []
          };

          this.$store.dispatch("gradeControl/addLocation", obj).then((response) => {
            this.$emit("onLocationInserted", response.data.model);
          }).finally(() => {
            this.initValues() });
        
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
